import React from 'react';

import ComboBox, {ComboboxItem} from '@pb/kit-component-combo-box';
import {Group} from '@pb/kit-component-group';
import Icon, {Icons} from '@pb/kit-component-icon';
import Label from '@pb/kit-component-label';
import {Tooltip} from '@pb/kit-component-popups';
import Typography from '@pb/kit-component-typography';

import {
    fields,
    section,
} from '../user-profile.module.styl';

type RoleItem = {
    value: string,
    label: string,
};

type Props = {
    roleItems: RoleItem[],
    selectedRoleId?: string,
    onRoleChange: (roleId: string) => void,
    disabled: boolean,
    canEditRoles?: boolean,
    resourcesLoading?: boolean,
};

export const PermissionDetailsCard: React.FC<Props> = ({
    roleItems,
    selectedRoleId,
    onRoleChange,
    disabled,
    canEditRoles = true,
    resourcesLoading = false,
}) => (
    <div className={section}>
        <Group justify="space-between" alignItems="center">
            <Typography className="font-weight-semi-bold" variant="heading-level-4">
                Permission Details
            </Typography>
        </Group>
        <div className={fields}>
            <div>
                <Group gap="xs" alignItems="center">
                    <Label>Role</Label>
                    <Tooltip
                        color="light"
                        placement="right"
                        anchor={({getAnchorProps, anchorRef}) => (
                            <Icon
                                ref={anchorRef}
                                type={Icons.INFO}
                                color="grayDark"
                                aria-label="Role descriptions"
                                {...getAnchorProps()}
                            />
                        )}>
                        <div style={{maxWidth: 420}}>
                            <div style={{fontWeight: 600, marginBottom: 6}}>
                                PB Admin
                            </div>
                            <div style={{marginBottom: 12}}>
                                A user belonging to a PitchBook Data account who has the authority to create and edit
                                Vendors, add Vendor Admins, change the status of Entitlement entities to Managed, view a
                                list of all existing requests for all Vendors, but does not have the authority to make
                                decisions about approving or denying access to data.
                            </div>
                            <div style={{fontWeight: 600, marginBottom: 6}}>
                                Vendor Admin
                            </div>
                            <div style={{marginBottom: 12}}>
                                A Vendor representative who has access to the Vendor Portal and the authority to make
                                decisions about approving or denying access to the dataset.
                            </div>
                            <div style={{fontWeight: 600, marginBottom: 6}}>
                                PB Support
                            </div>
                            <div>
                                A user belonging to a PitchBook Data account who has the authority to view a list of all
                                existing requests for all Vendors, but does not have the authority to make decisions
                                about approving or denying access to the data, or the authority to take any other
                                actions.
                            </div>
                        </div>
                    </Tooltip>
                </Group>
                <ComboBox<string | undefined, string>
                    value={selectedRoleId}
                    onChange={onRoleChange}
                    placeholder="Select role"
                    disabled={disabled || resourcesLoading || !canEditRoles}>
                    {roleItems.map(role => (
                        <ComboboxItem key={role.value} caption={role.label} value={role.value}/>
                    ))}
                </ComboBox>
            </div>
        </div>
    </div>
);
